module.exports = __webpack_public_path__ + "fonts/48b7a52.eot";